import { DateTime } from "luxon";
import { z } from "zod";

export const E164PhoneNumberSchema = z
  .string()
  .regex(/^\+1\d{10}$/, "Must be a valid E.164-formatted phone number");

export const ShortCodeOrE164PhoneNumberSchema = z
  .string()
  .regex(
    /^(\d{5,6}|\+1\d{10})$/,
    "Must be a valid 5-digit or 6-digit short code or an E.164-formatted US phone number"
  );

export const STW_HOLIDAYS: string[] = [
  "2025-09-01",
  "2025-11-11",
  "2025-11-27",
  "2025-11-28",
  "2025-12-24",
  "2025-12-25",
  "2025-12-26",
  "2025-12-27",
  "2025-12-28",
  "2025-12-29",
  "2025-12-30",
  "2025-12-31",
  "2026-01-01",
  "2026-01-02",
];

export function findNextBusinessDay(
  possibleDate: DateTime,
  addDays: number
): DateTime {
  let daysRemaining = addDays;
  let dateForFuture = DateTime.fromJSDate(possibleDate.toJSDate());

  while (daysRemaining > 0) {
    if (dateForFuture.weekdayLong === "Saturday") {
      dateForFuture = dateForFuture.plus({ days: 2 });
    } else if (dateForFuture.weekdayLong === "Sunday") {
      dateForFuture = dateForFuture.plus({ days: 1 });
    } else {
      dateForFuture = dateForFuture.plus({ days: 1 });
      daysRemaining--;
    }
  }

  return dateForFuture;
}

export const findEarliestStartDate = (timeStamp?: DateTime): DateTime => {
  const currentTime =
    timeStamp?.startOf("day") || DateTime.now().startOf("day");
  return findNextBusinessDay(currentTime, 3);
};
